<template>
  <div>
    <h1>{{ t('test.title') }}</h1>
    <p>{{ t('test.description') }}</p>
    <ul>
      <li>{{ t('test.item1') }}</li>
      <li>{{ t('test.item2') }}</li>
      <li>{{ t('test.item3') }}</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped>
h1 {
  color: #42b983;
}
</style> 